import { Component } from '@angular/core';

@Component({
  selector: 'fury-error-crawling-web-form',
  templateUrl: './error-crawling-web-form.component.html'
})
export class ErrorCrawlingWebFormComponent {}
